$(document).ready(function () {
    //AOS.init();
  $('.dropdown').click(function(){
    $(this).find('.dropdown-menu').slideToggle()
  })
    var megaLink, targetMegaMenu;
    $(".bf_megaLink_inner").mouseenter(function () {
        megaLink = $(this);
        targetMegaMenu = $(this).attr('data-id');
        $(".bf_megaLink_inner").not($(megaLink)).removeClass('bf_megaMenu_active');
        $(megaLink).addClass('bf_megaMenu_active');
        $(".bf_megaMenu_right_inner").not($(targetMegaMenu)).removeClass('bf_megaMenu_right_show');
        $(targetMegaMenu).addClass('bf_megaMenu_right_show');
//       	For grandsublink
      	$('.bf_grand-submenu').removeClass('bf_grand-submenu-active')
        $(this).parent().next().addClass('bf_grand-submenu-active')
    }).mouseleave(function (e) {
        if ($(targetMegaMenu + ":hover").length > 0) {
            $(targetMegaMenu).hover(function () {
                $(".bf_megaLink_inner").not($(megaLink)).removeClass('bf_megaMenu_active');
                $(megaLink).addClass('bf_megaMenu_active');
                $(".bf_megaMenu_right_inner").not($(targetMegaMenu)).removeClass('bf_megaMenu_right_show');
                $(targetMegaMenu).addClass('bf_megaMenu_right_show');
                // $(targetMegaMenu).addClass('bf_megaMenu_right_show');
            }, function () {
                // $(".bf_megaMenu_right_inner").removeClass('bf_megaMenu_right_show');
                // $(".bf_megaLink_inner").removeClass('bf_megaMenu_active');
                // $("#d35_menu").addClass('bf_megaMenu_right_show');
                // $(".bf_default_link").addClass('bf_megaMenu_active');
            });
        } else {
            // $(".bf_megaMenu_right_inner").removeClass('bf_megaMenu_right_show');
            // $(".bf_megaLink_inner").removeClass('bf_megaMenu_active');
            // $("#d35_menu").addClass('bf_megaMenu_right_show');
            // $(".bf_default_link").addClass('bf_megaMenu_active');
        }
    });

    function f() {
        if ($(window).width() > 992) {
            var targetMenu, currentEle;
            $(".bf_main_nav .bf_navItem").mouseenter(function () {
                currentEle = $(this);
                $(".bf_main_nav .bf_navItem").removeClass('bf_active_dropDown_link');
                $(this).addClass('bf_active_dropDown_link');
                clearTimeout($(this).data('timeoutId'));
                $(".bf_navBar").removeClass('bf_active_megaMenu');
                targetMenu = $(this).attr('data-trigger');
                $(targetMenu).addClass('bf_active_megaMenu');
              $(".bf_navBar").addClass('bf_active_mainNav');
              	//$('.bf_navBar').css('color', 'black');
              //$('.bf_Logo_outer img').toggle()
            }).mouseleave(function (e) {
                $(".bf_main_nav .bf_navItem").removeClass('bf_active_dropDown_link');
                if ($(targetMenu + ":hover").length > 0) {
                    $(targetMenu).hover(function () {
                        $(currentEle).addClass('bf_active_dropDown_link');
                        $(".bf_navBar").addClass('bf_active_mainNav');
                    }, function () {
                        $(targetMenu).removeClass('bf_active_megaMenu');
                      //$('.bf_Logo_outer img').toggle()
                        $(currentEle).removeClass('bf_active_dropDown_link');
                        $(".bf_navBar").removeClass('bf_active_mainNav');
                    });
                } else {
                    $(targetMenu).removeClass('bf_active_megaMenu');
                  $(".bf_navBar").removeClass('bf_active_mainNav');
                }
              //$('.bf_navBar').css('color', 'white');
            });
            $("ul.bf_main_nav").height('auto');
        } else {
            $("ul.bf_main_nav").height('calc(100vh - ' + $('header').height() + 'px)');
        }
    }

    f();

//     $("ul.bf_main_nav li.bf_navItem").click(function (e) {
      
//         e.preventDefault();
//       $("ul.bf_main_nav li ul li").click((e)=>window.location=e.target.href)
//         if ($(window).width() <= 992) {
//             $(this).find('i').toggleClass('fa-plus fa-minus');
//             $("ul.bf_main_nav li a.bf_navLink i").not($(this).find('i')).removeClass('fa-minus').addClass('fa-plus');
//             $("ul.bf_main_nav li ul").not($(this).find('ul')).slideUp();
//             $(this).find('.show_on_lg').slideToggle();
//         }
//     });
  
  $("ul.bf_main_nav li.bf_navItem i").click(function (e) {
        e.preventDefault();
        if ($(window).width() <= 992) {
          $(this).toggleClass('fa-plus fa-minus')
           $(this).parent().next().slideToggle()
        }
    });

    $(window).resize(function () {
        f();
    })

    $(".bf_footer_links .bf_footer_heading").click(function (e) {
        e.preventDefault();
        if ($(window).width() < 993) {
            $(".bf_footer_links ul").not($(this).next('ul')).slideUp();
            $(this).next('ul').slideToggle();
            $(".bf_footer_links .bf_footer_heading i").not($(this).find('i')).removeClass('fa-minus').addClass('fa-plus');
            $(this).find('i').toggleClass('fa-plus fa-minus');
        }
    })

    $(".bf_navbar_toggler").click(function (e) {
        e.preventDefault();
        $(this).find('i').toggleClass('fa-bars fa-xmark');
        $('body').toggleClass('bf_overflow_hidden');
    });

    $(".bf_overlay").click(function (e) {
        e.preventDefault();
        $('body').removeClass('bf_overflow_hidden');
        $(".bf_navbar_toggler i").removeClass('fa-xmark').addClass('fa-bars');
    });

    $(".bf_find_dealer_tab_head").click(function (e) {
        e.preventDefault();
        $(".bf_find_dealer_tab_head").not($(this)).removeClass('bf_is_open');
        $('.bf_find_dealer_tab_body').not($(this).next('.bf_find_dealer_tab_body')).slideUp();
        $(this).toggleClass('bf_is_open');
        $(this).next('.bf_find_dealer_tab_body').slideToggle();
    });
  
  $('.product__zoom-button').on('click', function(){
    var checkExist = setInterval(function() {
    if ($('product-image-zoom').length) {
      clearInterval(checkExist);
      $('product-image-zoom').css('z-index', '-1')
    }else{
    	$('product-image-zoom').css('z-index', '1')
    }
  }, 10);
  })
  
  
  
   $('.bf_cstm-bundle-product .product__media .product__zoom-button').on('click', function(){

    	$('.bf_composite_product').addClass('bf_composite_products_Sec');
    	
  });

  $('.bf_cstm-bundle-product .product__media .pswp .pswp__button--close').on('click', function(){

    	$('.bf_composite_product').removeClass('bf_composite_products_Sec');
  });
  
  
  
}); 